$(document).ready(function () {

    $('.repeater-diplome').repeater({
        show: function () {
            $(this).slideDown();
        }
    });

});